import { NoteMarkType } from '~/services/api/enums';
import styles from './Item.module.scss';

export const noteMarkClassMap: Record<NoteMarkType, string | undefined> = {
  [NoteMarkType.None]: undefined,
  [NoteMarkType.Emr]: styles.markEmr,
  [NoteMarkType.Triage]: styles.markTriage,
};

export default {};
